/* eslint-disable import/no-unresolved */
const constants = require('onestic-base/constants');
const slickSlider = require('onestic-base/components/slider');
const utils = require('onestic-base/utils');

const runSlick = (element) => {
    const { prev, next } = utils.getSliderLabels();
    setTimeout(() => {
        slickSlider.methods.useCustomizableSlick(
            element,
            true,
            `<button type="button" class="icon-left-arrow-line next no-btn" aria-label="${prev}"></button>`,
            `<button type="button" class="icon-right-arrow-line prev no-btn" aria-label="${next}"></button>`,
            4,
            {
                arrows: true,
                infinite: false,
                adaptiveHeight: true,
                responsive: [
                    {
                        breakpoint: constants.viewport_bootstrap.md,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            arrows: true,
                        },
                    },
                    {
                        breakpoint: constants.viewport_bootstrap.lg,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            arrows: true,
                        },
                    },
                ],
            },
        );
    }, 1000);
};

// eslint-disable-next-line consistent-return
const checkElement = (selector, fn) => {
    if ($(selector).length) {
        fn();
        return;
    }
    setTimeout(() => {
        checkElement(selector, fn);
    }, 100);
};

const runClickedSlick = (carouselToShow, scopeTarget) => {
    const carouselInitialized = $(scopeTarget).parent().find('.slick-initialized');

    if (!$(scopeTarget).hasClass('loaded')) {
        if (carouselInitialized.length) {
            carouselInitialized.slick('refresh');
        } else {
            runSlick(scopeTarget);
        }
    }
};

const clickHomeFeaturedProducts = () => {
    const tabs = $('.tabs-container .nav-item');

    tabs.on('click', (e) => {
        const element = $(e.currentTarget);
        const activeTab = `${element.find('a').attr('href')}`;

        checkElement(`.featured-products > ${activeTab}:not(.loaded) .product-carousel .product`, runClickedSlick.bind(null, '.product-carousel', `.featured-products > ${activeTab}:not(.loaded) .product-carousel`));
    });
};

const createCarouselTabs = () => {
    const carouselContainer = $('.featuredProduct-container > .featured-products');
    const carouselTabs = $('.featuredProduct-container > .featured-tabs');
    const calloutSlot = carouselContainer.find('.callout-slot');

    if (calloutSlot.length > 1) {
        carouselTabs.find('a').hide();

        calloutSlot.each((_index, el) => {
            const elem = $(el);
            const title = elem.attr('value');

            if (title.length) {
                const parentID = elem.parents('.featured-carousel-container').attr('id');

                carouselTabs.find(`a[href*='#${parentID}']`).text(title).show();
            }
        });

        $('.featuredProduct-container > .featured-tabs').removeClass('d-none');
        clickHomeFeaturedProducts();
    }
};

const slickConfig = () => {
    const activeTab = $('.featured-tabs .nav-link.active').attr('href');
    const activeCarousel = `.featured-products > ${activeTab} .product-carousel`;

    checkElement(`${activeCarousel} .product`, runSlick.bind(null, activeCarousel));
};

module.exports = () => {
    createCarouselTabs();
    slickConfig();
};
